import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useRefreshMutation } from "./authApiSlice";
import usePersist from "../../hooks/usePersist";
import { selectCurrentToken, logOut } from "./authSlice";
import Loading from "../../components/spinners/Loading";

const PersistLogin = () => {
  const [persist] = usePersist();
  const token = useSelector(selectCurrentToken);
  const dispatch = useDispatch();
  const location = useLocation();
  const [refresh, { isUninitialized, isLoading, isSuccess, isError }] =
    useRefreshMutation();
  const [trueSuccess, setTrueSuccess] = useState(false);

  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        console.log("🔄 Attempting token refresh...");
        const response = await refresh();
        console.log("✅ Full refresh response:", response);

        if (response?.data?.accessToken) {
          setTrueSuccess(true);
        } else {
          throw new Error("❌ No access token returned from server.");
        }
      } catch (err) {
        console.error("❌ Token refresh failed:", err);
        dispatch(logOut()); // Ensure the user is logged out if refresh fails
      }
    };

    if (!token && persist) {
      verifyRefreshToken();
    }
  }, [token, persist, refresh, dispatch]);

  let content;
  if (!persist) {
    content = <Outlet />;
  } else if (isLoading) {
    content = <Loading />;
  } else if (isError) {
    content = <Navigate to="/login" state={{ from: location }} replace />;
  } else if (isSuccess && trueSuccess) {
    content = <Outlet />;
  } else if (token && isUninitialized) {
    content = <Outlet />;
  }

  return content;
};

export default PersistLogin;
